module.exports = __webpack_public_path__ + "img/p1.46c42036.webp";